// ======================================================================
// File Name       : EnterpriseNotificationListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues, submit } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import DialogConfirm from '../../components/DialogConfirm';
import EnterpriseNotificationSearch from '../../components/enterpriseNotification/EnterpriseNotificationSearch';
import EnterpriseNotificationList from '../../components/enterpriseNotification/EnterpriseNotificationList';
import * as EnterpriseNotificationAction from '../../actions/enterpriseNotification/EnterpriseNotificationAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { VALIDATE_TYPE, RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SEARCH, WRITE } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import MessageSearch from '../../components/MessageSearch';
import Header from '../../components/Header';
import { ENTERPRISE_NOTIFICATION_LIST, ENTERPRISE_NOTIFICATION_DETAIL } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { ENTERPRISE_NOTIFICATION_REGISTER } from '../../constants/FunctionConstants';

class EnterpriseNotificationListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
    };
    this.searchData = this.searchData.bind(this);
    this.onExportDialogCancel = this.onExportDialogCancel.bind(this);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.openExportDialog = this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT, null);
    this.createParams = this.createParams.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.initData = this.initData.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { initialValues } = this.props;
    const filterData = {
      ...this.state,
      filterData: initialValues,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: ENTERPRISE_NOTIFICATION_LIST,
      searchCondition: formValues,
    });
  }

  goToDetail(noticeForEnterpriseSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: ENTERPRISE_NOTIFICATION_LIST,
        searchCondition: formValues,
      });
    }
    const path = ENTERPRISE_NOTIFICATION_DETAIL.replace(':id', noticeForEnterpriseSecernId);
    this.props.history.push(path);
  }

  initData() {
    const { initialValues, displayUserType } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.noticeSortType) {
        column = initialValues.noticeSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(false, initialValues, column, startPosition);
    this.props.dispatch(EnterpriseNotificationAction.searchEnterpriseNotification(param, displayUserType));
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid, displayUserType, institutionId } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      ...this.state.filterData,
      noticeTitle: formValues.noticeTitle,
      releaseTargetForEnterprise: formValues.releaseTargetForEnterprise,
      publicStatus: formValues.publicStatus,
      publicDateFrom: formValues.publicDateFrom,
      publicDateTo: formValues.publicDateTo,
      startPosition: formValues.startPosition,
      noticeSortType: formValues.noticeSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(false, filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('noticeSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(EnterpriseNotificationAction.searchEnterpriseNotification(paramSearch, displayUserType))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }
  /**
  * Action click cancel button in dialog
  */
  openExportDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }
  /**
  * Action click cancel button in dialog
  */
  onExportDialogCancel() {
    this.setState({ showExportModal: false });
  }

  /**
  * Action click OK button in diablog
  */
  onExportDialogOk() {
    // #6899 START
    const { displayUserType, formValues } = this.props;
    const paramExport = this.createParams(true, formValues);
    // #6899 END
    this.props.dispatch(EnterpriseNotificationAction.searchEnterpriseNotification(paramExport, displayUserType));
    this.setState({ showExportModal: false });
  }

  /**
  * Search button
  */
  searchData(startPosition, column) {
    const { formValues, invalid, dispatch, displayUserType } = this.props;
    const { filterData } = this.state;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(false, filterData, column, startPosition);
    this.props
      .dispatch(
        EnterpriseNotificationAction.searchEnterpriseNotification(paramSearch, displayUserType),
      )
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
  }
  /**
   *
   * @param {*} isCSV
   * @param {*} data
   * @param {*} column
   * @param {*} startPosition
   */
  createParams(isCSV, data, column, startPosition) {
    const { searchInfo, institutionId } = this.props;
    const filterData = {
      ...data,
    };
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }

    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.noticeSortType = column.sortBy;
    }

    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.noticeSortType = null;
    }

    let selectTargetData = 0;
    if (isCSV) {
      selectTargetData = 1;
    }

    filterData.publicDateFrom = data.publicDateFrom ? moment(data.publicDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SEARCH) : '';
    filterData.publicDateTo = data.publicDateTo ? moment(data.publicDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SEARCH) : '';
    filterData.releaseTargetForEnterprise = data.releaseTargetForEnterprise !== null
      ? parseInt(data.releaseTargetForEnterprise, 10) : null;
    filterData.publicStatus = data.publicStatus !== null ? parseInt(data.publicStatus, 10) : null;
    filterData.noticeTitle = data.noticeTitle;
    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      selectTargetData,
      searchInfo: filterData,
    };

    return param;
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.noticeSortType) {
      column = formValues.noticeSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { formValues, noticeForEnterpriseList, invalid, readOnlyFlag } = this.props; // #6899
    const { hoverIndex } = this.state;
    const canEditNoticeForEnterprise = canAccessRoute(ENTERPRISE_NOTIFICATION_REGISTER);
    return (
      <div>
        <MessageSearch
          recordNum={this.props.recordNum}
          resultList={noticeForEnterpriseList ? noticeForEnterpriseList.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="企業向けお知らせ一覧" />
        <EnterpriseNotificationSearch
          {...formValues} // #6899
          onSearchBtnClick={this.clickSearchButton}
          openExportDialog={this.openExportDialog}
          invalid={invalid}
          readOnlyFlag = {readOnlyFlag}
          canEditNoticeForEnterprise={canEditNoticeForEnterprise}
        />
        <EnterpriseNotificationList
          noticeForEnterpriseList={noticeForEnterpriseList}
          handleSortState={this.handleSortState}
          invalid={invalid}
          goToDetail={this.goToDetail}
          recordNum={this.props.recordNum}
          getStartEndData={this.getStartEndData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onExportDialogCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onExportDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { noticeForEnterpriseList } = state.enterpriseNotification;
  const { parentPath, searchCondition } = state.page;
  const { filterData } = state.enterpriseNotification;
  const { enterpriseNotification } = state.form;
  let recordNum = 0;
  let csvFileLink = '';
  if (noticeForEnterpriseList && noticeForEnterpriseList.recordNum) {
    recordNum = noticeForEnterpriseList.recordNum;
  }
  if (noticeForEnterpriseList && noticeForEnterpriseList.csvFileLink) {
    csvFileLink = noticeForEnterpriseList.csvFileLink;
  }
  const invalid = isInvalid('enterpriseNotification')(state);
  let searchInfo = filterData;
  const { userInfo, institutionId, readOnlyFlag } = state.authed.authedUser;
  const { displayUserType } = userInfo;
  if (state.enterpriseNotification.searchInfo) {
    searchInfo = state.enterpriseNotification.searchInfo;
  }
  let initial = {};
  if (parentPath === ENTERPRISE_NOTIFICATION_LIST) {
    if (searchCondition) {
      initial = searchCondition;
    }
  }

  return {
    ...{ noticeForEnterpriseList },
    ...{ enterpriseNotification },
    filterData,
    initialValues: initial,
    recordNum,
    csvFileLink,
    invalid,
    formValues: getFormValues('enterpriseNotification')(state),
    searchInfo,
    displayUserType,
    institutionId,
    readOnlyFlag,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'enterpriseNotification', // a unique identifier for this form
  touchOnChange: true,
})(EnterpriseNotificationListContainer));
